export enum PermissionKey {
  companyOptionManagement = 'COMPANY_OPTION_MANAGEMENT',
  companySettingLoginPass = 'COMPANY_SETTING_LOGIN_PASS',
  companyDeleteCareconneRole = 'COMPANY_DELETE_CARECONNE_ROLE',
  companyExportData = 'COMPANY_EXPORT_DATA',
  accountDeleteCareconneRole = 'ACCOUNT_DELETE_CARECONNE_ROLE',
  accountExportData = 'ACCOUNT_EXPORT_DATA',
  helpPostEdit = 'HELP_POST_EDIT',
  useTermUpdateEdit = 'USE_TERM_UPDATE_EDIT',
  adminRoleEditCcjAdmin = 'ADMIN_ROLE_EDIT_CCJ_ADMIN',
  adminRoleModifyCareconneConsoleRole = 'ADMIN_ROLE_MODIFY_CARECONNE_CONSOLE_ROLE',
  systemManagementExecution = 'SYSTEM_MANAGEMENT_EXECUTION',
}
